//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get'
import dayJs from 'dayjs'
import readingTime from 'reading-time'
import hasArticles from '~/mixins/hasArticles'
import { generateImageURL } from '~/utils/storage'
import Category from '~/models/Category'
import hasCategories from '~/mixins/hasCategories'
import Article from '~/models/Article'
import EditorialPickSlider from '~/components/editorial-pick/EditorialPickSlider'
import hasEditorialArticles from '~/mixins/hasEditorialArticles'

export default {
  components: { EditorialPickSlider },
  mixins: [hasArticles, hasCategories, hasEditorialArticles],

  async fetch({ error, store, query }) {
    try {
      const allParams = {
        ...query,
        limit: 9,
        page: 1,
      }
      await store.dispatch('articles/fetch', allParams)
      await store.dispatch('editorial-articles/fetch', allParams)
    } catch (e) {
      if (get(e, 'response.status') === 404) {
        error({ statusCode: 404, message: 'Artikel tidak ditemukan.' })
      } else {
        throw e
      }
    }
  },

  data() {
    return {
      editorialArticles: [],
      popularArticles: [],
      hasInitialize: true,
      params: {
        limit: 9,
        page: 1,
      },
      articles: [],
      didLoad: false,
      isLoading: false,
      isFetchingArticle: false,
      lastMeta: null,
    }
  },

  computed: {
    categoriesFiltered() {
      return this.getCategories(this.categoriesParams)
    },

    categoriesParams() {
      return {
        page: 1,
        orderBy: ['priority'],
        type: Category.TYPE_ARTICLE,
      }
    },
  },

  watch: {
    '$route.query'() {
      this.loadArticles()
      this.loadData()
      this.loadEditorialsPick()
    },
  },

  beforeMount() {
    this.fetchCategories(this.categoriesParams)
    this.loadData()
    this.loadArticles()
    this.loadEditorialsPick()
  },

  methods: {
    get,
    async loadEditorialsPick() {
      try {
        const allParams = {
          ...this.params,
          ...(this.$route?.query ? this.$route.query : {}),
        }
        await this.$store.dispatch('editorial-articles/fetch', allParams)
        this.editorialArticles = this.getEditorialArticles(allParams)
      } catch (e) {}
    },
    async loadArticles() {
      try {
        this.isFetchingArticle = true
        const allParams = {
          ...this.params,
          ...(this.$route?.query ? this.$route.query : {}),
        }
        await this.$store.dispatch('articles/fetch', allParams)
        this.articles = this.getArticles(allParams)
        this.lastMeta = get(this.getArticlesResult(allParams), 'meta')
      } catch (e) {
        this.isFetchingArticle = false
      } finally {
        this.isFetchingArticle = false
      }
    },
    async loadData() {
      try {
        const response = await this.$axios.get(`v1/popular-article`, {
          params: {
            page: 1,
            limit: 3,
            category_id: this.$route.query.category_id,
          },
        })
        this.popularArticles = response.data.data.map(
          (popularArticle) => new Article(popularArticle)
        )
      } catch (e) {}
    },
    async loadMore() {
      if (
        this.lastMeta &&
        this.lastMeta.current_page === this.lastMeta.last_page
      ) {
        return
      }

      try {
        this.isLoading = true
        const page = (this.lastMeta && this.lastMeta.current_page + 1) || 1
        const params = { ...this.$route.query, ...this.params, page }
        await this.fetchArticles(params)
        const articles = this.getArticles(params)
        this.articles = [...this.articles, ...articles]
        this.lastMeta = get(this.getArticlesResult(params), 'meta')
      } finally {
        this.isLoading = false
        this.didLoad = true
      }
    },
    generateImage(url) {
      return `${generateImageURL(url || '')}?&fit=crop`
    },
    getDate(date) {
      return dayJs(date).format('DD MMM YYYY')
    },
    getMinutes(min) {
      return min || 0
    },
    getReadingTime(content) {
      return readingTime(content).text
    },
    getTotalComment(comment) {
      return comment || 0
    },
  },

  head() {
    return {
      title: "Artikel | Charm Girl's Talk",
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Artikel Charm Girl’s Talk menyajikan informasi seputar menstruasi, pubertas, breast cancer, produk pembalut charm dan seputar pembahasan cewek lainnya dengan cara fun!',
        },
      ],
    }
  },
}
